export default function getFileHashError(message: string | undefined) {
  if (!message) return null;

  return fileHashAlertMessage[message];
}

type FileHashError = {
  title: string;
  description?: string;
};

const fileHashAlertMessage: Record<string, FileHashError> = {
  'Such ext is not allowed': {
    title: '선택한 문서가 검증할 수 없는 형식의 파일입니다.\n파일의 형식을 확인해 주세요.',
  },
  'Verification data is invalid': {
    title:
      '문서의 원본 검증키를 찾을 수 없습니다.\n서명 완료된 문서의 ID를 입력했는지 확인해 주세요.',
    description: '모든 서명자의 서명이 완료된 문서만 검증할 수 있습니다.',
  },
  'File size exceed max': {
    title: '선택한 문서가 업로드 최대 용량(30MB)을 초과합니다.\n파일의 용량을 확인해 주세요.',
  },
  'Image file is broken': {
    title: '손상된 파일입니다.\n선택한 파일을 확인해 주세요.',
  },
  'Network Error': {
    title: '문서 검증 중 네트워크 오류가 발생했습니다.\n네트워크 연결 상태를 확인해 주세요.',
  },
  'A requested file or directory could not be found at the time an operation was processed.': {
    title: '선택한 문서를 찾을 수 없습니다.\n이동 또는 삭제된 파일일 수 있습니다.',
  },
};
